import { isExperimentFlagEnabled } from './useExperimentFlag';

/**
 * Тестовый режим подключения кассы CloudKassir (SS-18482).
 *
 * У тестовой кассы CloudPayments нет заводского номера и номера ФН — все обращения
 * идут по Public ID, поэтому в тестовом режиме эти поля необязательны.
 * Бэкенд принимает пустые номера только на не-prod окружениях.
 *
 * @kind helper
 * @returns включён ли тестовый режим подключения кассы CloudKassir
 */
export const isCloudKassirTestModeEnabled = (): boolean =>
    isExperimentFlagEnabled('enable_cloud_kassir_test_mode', 'exp');

export const useExperimentCloudKassirTestMode = isCloudKassirTestModeEnabled;
